var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.30002 0.400024C1.97454 0.400024 0.900024 1.47454 0.900024 2.80002V17.2C0.900024 18.5255 1.97454 19.6 3.30002 19.6H17.7C19.0255 19.6 20.1 18.5255 20.1 17.2V2.80002C20.1 1.47454 19.0255 0.400024 17.7 0.400024H3.30002ZM11.7 4.00002C11.7 3.33728 11.1628 2.80002 10.5 2.80002C9.83728 2.80002 9.30002 3.33728 9.30002 4.00002V9.50297L7.74855 7.9515C7.27992 7.48287 6.52013 7.48287 6.0515 7.9515C5.58287 8.42013 5.58287 9.17992 6.0515 9.64855L9.6515 13.2486C10.1201 13.7172 10.8799 13.7172 11.3486 13.2486L14.9486 9.64855C15.4172 9.17992 15.4172 8.42013 14.9486 7.9515C14.4799 7.48287 13.7201 7.48287 13.2515 7.9515L11.7 9.50297V4.00002ZM5.70002 14.8C5.03728 14.8 4.50002 15.3373 4.50002 16C4.50002 16.6628 5.03728 17.2 5.70002 17.2H15.3C15.9628 17.2 16.5 16.6628 16.5 16C16.5 15.3373 15.9628 14.8 15.3 14.8H5.70002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.e1c832f3f8273ae47e76b7c28b8b13c1.svg";
export { ForwardRef as ReactComponent };